(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-audio-buttons"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Multi-track player: one global audio engine, but each track has its own UI control.
  function formatTime(s) {
    if (!s || isNaN(s)) return '0:00';
    var m = Math.floor(s/60);
    var sec = Math.floor(s % 60).toString().padStart(2,'0');
    return m + ':' + sec;
  }

  function initPab(container) {
    if (!container) return;
    var tracks = container.querySelectorAll('.pab-track');
    if (!tracks.length) return;

    // Create shared audio element to avoid multiple downloads (optional)
    var sharedAudio = new Audio();
    sharedAudio.preload = 'metadata';
    window.__pab_shared_audio = window.__pab_shared_audio || sharedAudio;

    // Helper to stop others
    function stopAllExcept(index) {
      tracks.forEach(function(t, i){
        var btn = t.querySelector('.pab-play');
        if (i !== index) {
          btn.classList.remove('playing');
          btn.innerHTML = '<span class="pab-icon">▶</span>';
        }
      });
    }

    tracks.forEach(function(trackEl, idx){
      var btn = trackEl.querySelector('.pab-play');
      var bar = trackEl.querySelector('.pab-bar');
      var progress = trackEl.querySelector('.pab-progress');
      var timeEl = trackEl.querySelector('.pab-time');
      var speed = trackEl.querySelector('.pab-speed');
      var audioEl = trackEl.querySelector('.pab-audio');

      // Use the audio URL from the <source> inside audio tag (or empty)
      var src = (audioEl.querySelector('source') && audioEl.querySelector('source').getAttribute('src')) || '';

      // click play button
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if (!src) return;

        // If different source, switch shared audio
        if (window.__pab_shared_audio.src !== src) {
          window.__pab_shared_audio.src = src;
        }

        // if paused -> play
        if (window.__pab_shared_audio.paused || window.__pab_shared_audio.src !== src) {
          stopAllExcept(idx);
          window.__pab_shared_audio.play().catch(function(){});
          btn.classList.add('playing');
          btn.innerHTML = '<span class="pab-icon">❚❚</span>';
        } else {
          window.__pab_shared_audio.pause();
          btn.classList.remove('playing');
          btn.innerHTML = '<span class="pab-icon">▶</span>';
        }
      });

      // bar click to seek
      bar.addEventListener('click', function(e){
        if (!src) return;
        var rect = bar.getBoundingClientRect();
        var pct = (e.clientX - rect.left) / rect.width;
        if (!isFinite(window.__pab_shared_audio.duration) || isNaN(window.__pab_shared_audio.duration)) return;
        window.__pab_shared_audio.currentTime = pct * window.__pab_shared_audio.duration;
      });

      // speed change
      speed.addEventListener('change', function(){
        window.__pab_shared_audio.playbackRate = parseFloat(speed.value || 1);
      });

      // update UI when shared audio changes
      function updateUI(){
        // if audio src matches this track's src, update progress/time
        if (!src) return;
        if (window.__pab_shared_audio.src && window.__pab_shared_audio.src.indexOf(src) !== -1) {
          var dur = window.__pab_shared_audio.duration || 0;
          var cur = window.__pab_shared_audio.currentTime || 0;
          var pct = dur ? (cur / dur) * 100 : 0;
          progress.style.width = pct + '%';
          timeEl.textContent = formatTime(cur);
        }
      }

      // When playback starts/pauses/updates globally
      window.__pab_shared_audio.addEventListener('timeupdate', updateUI);
      window.__pab_shared_audio.addEventListener('pause', function(){
        // if paused, reset buttons
        stopAllExcept(-1);
      });
      window.__pab_shared_audio.addEventListener('ended', function(){
        stopAllExcept(-1);
      });

      // When switching source, reset UI
      window.__pab_shared_audio.addEventListener('loadedmetadata', function(){
        // update UI one time
        updateUI();
      });

      // also keep UI consistent if user clicks another track
      document.addEventListener('click', function(e){
        // no action here except to ensure global stop on navigation if needed
      });
    });
  }

  // init on DOM ready and on Shopify section reload
  function initAll() {
    document.querySelectorAll('[id^="product-audio-buttons-"]').forEach(function(container){
      initPab(container);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    // some themes pass the section DOM in e.target
    if (e.target && e.target.querySelector) {
      if (e.target.querySelector('[id^="product-audio-buttons-"]')) {
        initAll();
      }
    } else {
      initAll();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
